import { TOfferContextData } from '../../../../types/offer-card';

export const getQualityLevelInfo = (offerData: TOfferContextData) => {
  return offerData.offer.user?.agentModerationInfo?.qualityLevelInfo;
};

export const getAgentLevelInfo = (offerData: TOfferContextData) => {
  if (getQualityLevelInfo(offerData)) {
    return null;
  }

  return offerData.offer.user?.agentModerationInfo?.userLevelInfo;
};

export const getIsUserIdentifiedByDocuments = (offerData: TOfferContextData) => {
  const qualityLevelInfo = getQualityLevelInfo(offerData);

  if (qualityLevelInfo) {
    const { hasVerifiedDocuments, levelOrder = 0 } = qualityLevelInfo;

    return !!hasVerifiedDocuments && levelOrder < 4;
  }

  return !!offerData.offer.user?.agentModerationInfo?.userLevelInfo?.hasVerifiedDocuments;
};

export const getQualityLevelSystemName = (offerData: TOfferContextData) => {
  return offerData.offer.user?.agentModerationInfo?.qualityLevelInfo?.levelSystemName;
};
